import React, { useState, useEffect, useRef } from "react";
import { MdOutlineEnergySavingsLeaf, MdEmojiEvents } from "react-icons/md";
import { FaHandHoldingWater, FaSchool, FaDownload, FaPeopleCarry, FaFilter } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood, IoMan } from "react-icons/io5";
import { FaBoxesPacking, FaBox } from "react-icons/fa6";
import { GiTeacher } from "react-icons/gi";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { Container, Image, Button, Form, Table } from "react-bootstrap";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import Helper from "../../../helper/Common_Helper"
import ApexChartMonthWise from "./ApexChartMonthWise";
import ApexChartQuarterWise from "./ApexChartQuarterWise";
import healthy from "../../../assets/images/yoga.png";
import food from "../../../assets/images/sustainable_food_system.png";
import ewaste from "../../../assets/images/renewable.png";
import waste from "../../../assets/images/reduce_waste.png";
import energy from "../../../assets/images/energy-saving.png";
import water from "../../../assets/images/save-water.png";
import plastic from "../../../assets/images/no-plastic.png";
import { toast } from "react-toastify";
import CircleChart2 from "./pieChartLevel2.jsx";
import { FaAngleDown } from "react-icons/fa6";
import { FcCollaboration } from "react-icons/fc";
import DynamicCount from "../../../helper/AutoMation";
import LineCharts from "./LineChart2.jsx";
import ApexChartHeatmap from './ApexHeatChart4';
import ApexChartHeatmap2 from './ApexHeatChart2';
import BarCharts from "./BarCharts";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { IoMdRefreshCircle } from "react-icons/io";

function LevelTwoDashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);
    const [countData, setCountData] = useState({})
    const [districtWiseData, setDistrictWiseData] = useState({})
    const [filterDistrict, setFilterDistrict] = useState([]);
    const [filteredSchool, setFilteredSchool] = useState([]);
    const [stateID, setStateID] = useState('');
    const [selectYear, setYear] = useState('');
    const [themeWiseCount, setThemeWiseCount] = useState([]);
    const [schooCount, setSchooCount] = useState({})
    const [isFilterShow, setIsFilterShow] = useState(true);
    const [quarterWiseData, setQuarterWiseData] = useState([])
    const [monthWiseData, setMonthWiseData] = useState([])
    const [chartStatus, setChartStatus] = useState(1)
    const [timeFilter, setTimeFilter] = useState(false)
    const [quickNum, setQuickNum] = useState("")

    const [filterData, setFilterData] = useState(location?.state?.data || {
        state: "",
        district: "",
        theme_name: "",
        sub_themes: "",
        school_name: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    })


    useEffect(() => {
        setFilterData({['state']:'Uttar Pradesh'})
        if (filterData.state) {
            localStorage.setItem('filterDataState', filterData.state);
        }
    }, [filterData.state]);


    useEffect(() => {
        getCount(filterData);
    }, [filterData]);

    useEffect(() => {
        let StateId = StateList.find(obj => obj.state_name == filterData.state)?.state_id;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == 34);
        setFilterDistrict(filterdistrictList);
    }, [])

    const handleSelectState = (data) => {
        setStateID(data);
        setFilteredSchool([])
        let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
        setFilterDistrict(filterdistrictList);
        setFilterData(prevData => ({ ...prevData, state: StateName, district: '', school_name: "" }));
        getSchoolList({ state_id: data })
    }

    const handleSelectDistrict = async (value) => {
        setFilteredSchool([])
        setFilterData(prevData => ({ ...prevData, district: value, school_name: "" }));
        let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
        getSchoolList({ state_id: stateID, district_id: districtid })
    }

    const handleSelectTheme = async (value) => {
        setFilterData(prevData => ({ ...prevData, theme_name: value, sub_themes: "" }));
    }

    const handleFilterChange = (field, value) => {
        if (field === "toDate") {
            if (filterData?.fromDate && new Date(filterData?.fromDate) > new Date(value)) {
                toast.error('Start date cannot be greater than end date');
                return;
            }
        }
        setFilterData(prevData => ({ ...prevData, [field]: value }));
    }

    const getSchoolList = async (data) => {
        try {
            let response = await axiosConn('post', 'get-school-filter', data)
            if (response.data.status === 'success') {
                setFilteredSchool(response.data.result)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getCount = async (data) => {
        try {
            const response = await axiosConn('post', `admin-dashboard-count-district-wise`, data);
            if (response.data.status === 'success') {
                const finalData = response?.data?.data?.dataCount;
                setSchooCount({ totalSchoolCount: response?.data?.data?.schoolCount });
                setCountData(finalData);
                setDistrictWiseData(finalData.districtWiseCount);
                setThemeWiseCount(finalData.themeWiseCount);
                setQuarterWiseData(finalData.quarterWise);
                setMonthWiseData(finalData.monthWise);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleClickFilter = (district, filter) => {
        let data = { ...filterData, district };
        data['district'] = district;

        if (filter) {
            if (filter.implemnt_mode) {
                data['implemnt_mode'] = filter.implemnt_mode;
            }
            if (filter.event_type) {
                data['event_type'] = filter.event_type;
            }
        }
        navigate("/admin/view-state", { state: { state:'Uttar Pradesh' , data: data } })
    }
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setTimeFilter(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const applyQuickSelect = (quickSelect) => {
        const today = new Date();
        let startDate = null;
        let endDate = new Date();
    
        const quickSelectRanges = {
            last3Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 3);
            },
            last7Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 7);
            },
            last15Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 15);
            },
            lastMonth: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 1);
            },
            last3Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 3);
            },
            last6Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 6);
            },
            currentYear: () => {
                startDate = new Date(today.getFullYear(), 0, 1);
            },
            previousYear: () => {
                startDate = new Date(today.getFullYear() - 1, 0, 1);
                endDate = new Date(today.getFullYear() - 1, 11, 31);
            },
        };
    
        if (quickSelectRanges[quickSelect]) {
            quickSelectRanges[quickSelect]();
        } else {
            return;
        }
    
        setFilterData(prevData => ({
            ...prevData,
            fromDate: startDate.toISOString().split('T')[0],
            toDate: endDate.toISOString().split('T')[0]
        }));
        setTimeFilter(false);
    };

const handleQuickSelect = (period) => {
    applyQuickSelect(period);
};
    // Function to calculate start and end dates of the selected year
    const calculateYearRange = (year) => {
        if (!year) return { start: '', end: Helper.currentOrPastDate() };

        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;

        return { start: startDate, end: endDate };
    };
    // Calculate the date range for the selected year
    const { start, end } = calculateYearRange(selectYear);

    const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()
  const exportDashboardToPDF = async () => {
    const pdf = new jsPDF("p", "pt", "a4");
    
    // Set initial Y position for content
    let yPos = 20;
    
    // Title
    pdf.setFontSize(18);
    pdf.text("State Admin Dashboard", 20, yPos);
    yPos += 30;

    // 1. Events Summary Section
    pdf.setFontSize(14);
    pdf.text("Events Summary", 20, yPos);
    yPos += 20;

    if (countData?.themeWisetotalEventCount) {
        const eventsData = Object.entries(countData.themeWisetotalEventCount).map(([key, val]) => ({
            Theme: key,
            Total: val.totalEvent,
            Completed: val.completedEvent,
            Ongoing: val.ongoingEvent,
            Initiated: val.initiateEvent
        }));
        pdf.autoTable({
            startY: yPos,
            head: [["Theme", "Total", "Completed", "Ongoing", "Initiated"]],
            body: eventsData.map(Object.values),
        });
        yPos += pdf.lastAutoTable.finalY + 20;
    }

    // 2. Schools Summary Section
    pdf.text("Schools Summary", 20, yPos);
    yPos += 20;

    if (countData?.stateWiseCount) {
        const schoolData = Object.entries(countData.stateWiseCount).map(([state, counts]) => ({
            State: state,
            Total: counts.totalCount,
            Completed: counts.completedEvent,
            Ongoing: counts.ongoingEvent,
            Initiated: counts.initiateEvent,
            Physical: counts.physicalCount,
            Digital: counts.digitalCount
        }));
        pdf.autoTable({
            startY: yPos,
            head: [["States/UTs/ABs", "Total", "Completed", "Ongoing", "Initiated", "Physical", "Digital"]],
            body: schoolData.map(Object.values),
        });
        yPos += pdf.lastAutoTable.finalY + 20;
    }

    // 3. Collaboration Count Section
    pdf.text("Collaboration Summary", 20, yPos);
    yPos += 20;

    pdf.autoTable({
        startY: yPos,
        head: [["Collaboration Count"]],
        body: [[countData?.CollaborationCount || 0]],
    });
    yPos += pdf.lastAutoTable.finalY + 20;

    // 4. Charts (Capturing charts as images)
    pdf.text("Charts", 20, yPos);
    yPos += 20;

    // Capture a chart element, e.g., the line chart
    const chartElement = document.querySelector(".lineChart"); // Replace with your chart class or ID
    if (chartElement) {
        const canvas = await html2canvas(chartElement);
        const imgData = canvas.toDataURL("image/png");
        pdf.addImage(imgData, "PNG", 20, yPos, 500, 200); // Adjust the size as needed
        yPos += 220;
    }

    // Repeat this process for other charts as needed
    const barChartElement = document.querySelector(".barCharts"); // Replace with your bar chart class or ID
    if (barChartElement) {
        const canvas = await html2canvas(barChartElement);
        const imgData = canvas.toDataURL("image/png");
        pdf.addImage(imgData, "PNG", 20, yPos, 500, 200); // Adjust the size as needed
        yPos += 220;
    }

    // Save the PDF
    pdf.save("State_admin_Dashboard.pdf");
};
const resetFilterData = () => {
    setStateID('');
    setFilterDistrict([]);
    setFilteredSchool([]);
    setFilterData({
        state: "",
        district: "",
        school_name: "",
        theme_name: "",
        sub_themes: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    });
    window.location.reload();
};

    return (
        <>
            <section className="scholdashbrdSec superAdminDashboardSec">
                <Container fluid>
                    <div className="dashbrdTopSrchDiv lavel mt-3 mb-1" style={{position:"relative", zIndex:999}}>
                        <h2>State/District <span className="hdngBrkr"> Level </span> SNAPSHOT</h2>
                        <h3 style={{letterSpacing: "0.1em"}}>Welcome State Admin</h3>
                        <div className="text-end">
                            <Button onClick={() => setIsFilterShow(!isFilterShow)}><FaFilter size={20} color="#dddddd" /> Filter</Button>
                            <Button onClick={resetFilterData}><IoMdRefreshCircle size={22} color="#dddddd" /> Refresh</Button>
                            <Button onClick={exportDashboardToPDF}>Export Dashboard to PDF</Button>
                        </div>
                        {isFilterShow && (
                            <div className="filter my-4">
                                <div className="container-fluid">
                                    <div className="row gy-3">
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="state" disabled={true} className="form-control" value={StateList.find(list => list.state_name === filterData.state)?.state_id || ''} onChange={(e) => handleSelectState(e.target.value)}>
                                                    <option value="">All States/UTs/ABs</option>
                                                    {
                                                        console.log(StateList,"state id")
                                                    }
                                                    {StateList.map((list, i) => (
                                                        <option disabled={true} key={i} value={list.state_id}>{list.state_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="district" className="form-control" value={filterData.district} onChange={(e) => { handleSelectDistrict(e.target.value) }}>
                                                    <option value="">All District</option>
                                                    {filterDistrict.map((list, i) => (
                                                        <option key={i} value={list.district_name}>{list.district_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="school_name" className="form-control" value={filterData.school_name} onChange={(e) => handleFilterChange('school_name', e.target.value)}>
                                                    <option value="">All School</option>
                                                    {filteredSchool && filteredSchool.map((school, i) => (
                                                        <option key={i} value={school.school_name}>{school.school_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="theme_name" className="form-control" value={filterData.theme_name} onChange={(e) => { handleSelectTheme(e.target.value) }}>
                                                    <option value="">All Theme</option>
                                                    {ThemeBaseRouting.map((list, i) => (
                                                        <option value={list.value}>{list.lable}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="sub_themes" className="form-control" value={filterData.sub_themes} onChange={(e) => handleFilterChange('sub_themes', e.target.value)}>
                                                    <option value="">All Sub Theme</option>
                                                    {filterData.theme_name && subThemes[filterData.theme_name]?.map((list, i) => (
                                                        <option value={list.value}>{list.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="card-stats" ref={dropdownRef}>
                                                <button className="buttongreen form-control d-flex justify-content-between align-items-center" onClick={() => setTimeFilter(!timeFilter)}>Select Duration<FaAngleDown /></button>
                                                {timeFilter ? (
                                                    <div className="contentTime d-flex justify-content-between align-items-start flex-wrap">
                                                        <div className="leftArea">
                                                            <h5 className="text-center">Absolute time range</h5><hr />
                                                            <div className="card-stats">
                                                                <select name="selectYear" className="form-control" value={selectYear}
                                                                    onChange={(e) => { setYear(e.target.value); setFilterData({ fromDate: '', toDate: '' }); }}>
                                                                    <option value="">All Years</option>
                                                                    <option value="2023">2023</option>
                                                                    <option value="2024">2024</option>
                                                                    <option value="2025">2025</option>
                                                                </select>
                                                            </div>
                                                            <div className="srchBx _sr1 w-100">
                                                                <label style={{ marginTop: '10px' }} htmlFor="fromDate">From Date</label>
                                                                <input type="date" name="fromDate" min={start || ''} max={end || Helper.currentOrPastDate()}
                                                                    className="form-control" value={filterData.fromDate}
                                                                    onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="srchBx _sr1 w-100">
                                                                <label style={{ marginTop: '10px' }} htmlFor="toDate">To Date</label>
                                                                <input type="date" name="toDate" min={filterData.fromDate || ''}
                                                                    max={end || Helper.currentOrPastDate()} className="form-control"
                                                                    value={filterData.toDate} onChange={(e) => { handleFilterChange('toDate', e.target.value); setTimeFilter(false) }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="RightArea">
                                                            <h5 className="text-center">Quick Ranges</h5>
                                                            <hr />
                                                            <ul>
                                                                <li className={quickNum === 1 ? "active" : ""} onClick={() => { setQuickNum(1); handleQuickSelect('last3Days'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 1} readOnly /> Last 3 Days</li>
                                                                <li className={quickNum === 2 ? "active" : ""} onClick={() => { setQuickNum(2); handleQuickSelect('last7Days'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 2} readOnly /> Last 7 Days</li>
                                                                <li className={quickNum === 3 ? "active" : ""} onClick={() => { setQuickNum(3); handleQuickSelect('last15Days'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 3} readOnly /> Last 15 Days</li>
                                                                <li className={quickNum === 4 ? "active" : ""} onClick={() => { setQuickNum(4); handleQuickSelect('lastMonth'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 4} readOnly /> Last Month</li>
                                                                <li className={quickNum === 5 ? "active" : ""} onClick={() => { setQuickNum(5); handleQuickSelect('last3Months'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 5} readOnly /> Last 3 Months</li>
                                                                <li className={quickNum === 6 ? "active" : ""} onClick={() => { setQuickNum(6); handleQuickSelect('last6Months'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 6} readOnly /> Last 6 Months</li>
                                                                <li className={quickNum === 7 ? "active" : ""} onClick={() => { setQuickNum(7); handleQuickSelect('currentYear'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 7} readOnly /> Current Year</li>
                                                                <li className={quickNum === 8 ? "active" : ""} onClick={() => { setQuickNum(8); handleQuickSelect('previousYear'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 8} readOnly /> Previous Year</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        
              

                                        {/* <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="event_type" className="form-control" value={filterData.event_type} onChange={(e) => handleFilterChange('event_type', e.target.value)}>
                                                    <option value="">All Type of Event</option>
                                                    <option value="Action">Action</option>
                                                    <option value="Awareness">Awareness</option>
                                                    <option value="Action & Awareness both">Action & Awareness both</option>
                                                </select>
                                            </div>
                                        </div> 
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="implemnt_mode" className="form-control" value={filterData.implemnt_mode} onChange={(e) => handleFilterChange('implemnt_mode', e.target.value)}>
                                                    <option value="">All Mode of Implementation</option>
                                                    <option value="Digital">Digital</option>
                                                    <option value="Physical">Physical</option>
                                                </select>
                                            </div>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="dashbrdTopSrchDivlavel mt-2 mb-0" style={{position:"relative", zIndex:0}}>
                        <div className="d-flex justify-content-center">
                            <div className="boxdiv boxdivOne">
                            <div className="d-flex justify-content-between p-3">
                <div>
                    <p>Number of <span className="text-success w100">Events</span></p>
                    <h2 onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , category: "Events", type: "Total" } })}>
                        {countData.totalCount}
                    </h2>
                </div>
                <MdEmojiEvents size={80} color="#969640" />
            </div>
            <div className="d-flex justify-content-between bg-success bottomBox">
                <div className="bgdanger w-50">
                    <p>Completed</p>
                    <h2 onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , category: "Events", type: "Completed" } })}>
                        {countData.completedCount}
                    </h2>
                </div>
                <div className="bgdanger w-50">
                    <p>Ongoing</p>
                    <h2 onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , category: "Events", type: "Ongoing" } })}>
                        {countData.pendingCount}
                    </h2>
                </div>
            </div>
                            </div>
                            <div className="boxdiv boxdivTwo">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of <span className="text-success w100">Schools</span></p>
                                        <h2>{schooCount.totalSchoolCount || 0}</h2>
                                    </div>
                                    <FaSchool size={80} color="#9c6829" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-50">
                                        <p>Event Hosts</p>
                                        <h2>{countData.usedSchoolCount || 0}</h2>
                                    </div>
                                    <div className="bgdanger w-50">
                                        <p>Yet to Host</p>
                                        <h2>{schooCount.totalSchoolCount - countData.usedSchoolCount || 0}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivThree">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of <span className="text-success w100">Participants</span></p>
                                        <h2 style={{ height: 42 }}></h2>
                                    </div>
                                    <FaPeopleCarry size={80} color="#9f4d9b" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p></p>
                                        <h2>{countData.numberOfParticipants || 0}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivFour">
                            <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Total Number of <span className="text-success w100">Collaboration</span></p>
                                        <h2 style={{ height: 42 }}></h2>
                                    </div>
                                    <FcCollaboration size={80} color="#839c30" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p> </p>
                                        <h2 style={{ height: 42 }} onClick={() => navigate('/admin/collaboration', { state: { state:'Uttar Pradesh' , category: "Collaborations" } })}>
                        <DynamicCount value={countData?.CollaborationCount || 0} />
                    </h2>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </Container>

                {/* <Container fluid>
                    <div className="dashbrdTopSrchDiv activityListNewDiv mt-4">
                        <h4>Number of Events (Theme wise)</h4>
                        <ul>
                            <li>
                                <a href="#">
                                    <span><Image src={healthy} /></span>
                                    Adopt Healthy Lifestyles
                                    <b className="actNum">{themeWiseCount.lifestylesAdoptedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={food} /></span>
                                    Adopt Sustainable Food Systems
                                    <b className="actNum">{themeWiseCount.foodSystemsCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={ewaste} /></span>
                                    Reduce E-Waste
                                    <b className="actNum">{themeWiseCount.eWasteReducedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={waste} /></span>
                                    Reduce Waste
                                    <b className="actNum">{themeWiseCount.wasteReducedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={energy} /></span>
                                    Save Energy
                                    <b className="actNum">{themeWiseCount.energySavedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={water} /></span>
                                    Save Water
                                    <b className="actNum">{themeWiseCount.waterSavedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={plastic} /></span>
                                    Say No to Single Use Plastic
                                    <b className="actNum">{themeWiseCount.plasticReducedCount || 0}</b>
                                </a>
                            </li>
                        </ul>
                    </div>
                </Container> */}

<Container fluid>
    <div className="container-wrapper mt-4">
        <h4>Number of Events (Theme Wise)</h4>
        <ul className="theme-list">
        <li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D5F2E3' }}>
            <span className="theme-icon">
                <Image src={healthy} alt="Adopt Healthy Lifestyles" fluid />
            </span>
            <p>Adopt Healthy Lifestyles</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Healthy Lifestyles", type: 'Total' } })}>
                        <b>{themeWiseCount.lifestylesAdoptedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Healthy Lifestyles", type: 'Completed' } })}>
                        <b>{themeWiseCount.lifestylesCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Healthy Lifestyles", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.lifestylesOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Healthy Lifestyles", type: 'Initiated' } })}>
                        <b>{themeWiseCount.lifestylesInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FEE2E2' }}>
            <span className="theme-icon">
                <Image src={food} alt="Adopt Sustainable Food Systems" fluid />
            </span>
            <p>Adopt Sustainable Food Systems</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Sustainable Food Systems", type: 'Total' } })}>
                        <b>{themeWiseCount.foodSystemsCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Sustainable Food Systems", type: 'Completed' } })}>
                        <b>{themeWiseCount.foodSystemsCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Sustainable Food Systems", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.foodSystemsOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Adopt Sustainable Food Systems", type: 'Initiated' } })}>
                        <b>{themeWiseCount.foodSystemsInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FFF3CD' }}>
            <span className="theme-icon">
                <Image src={ewaste} alt="Reduce E-Waste" fluid />
            </span>
            <p>Reduce E-Waste</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce E-Waste", type: 'Total' } })}>
                        <b>{themeWiseCount.eWasteReducedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce E-Waste", type: 'Completed' } })}>
                        <b>{themeWiseCount.eWasteCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce E-Waste", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.eWasteOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce E-Waste", type: 'Initiated' } })}>
                        <b>{themeWiseCount.eWasteInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D1E7DD' }}>
            <span className="theme-icon">
                <Image src={waste} alt="Reduce Waste" fluid />
            </span>
            <p>Reduce Waste</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce Waste", type: 'Total' } })}>
                        <b>{themeWiseCount.wasteReducedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce Waste", type: 'Completed' } })}>
                        <b>{themeWiseCount.wasteCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce Waste", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.wasteOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Reduce Waste", type: 'Initiated' } })}>
                        <b>{themeWiseCount.wasteInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#E2E3E5' }}>
            <span className="theme-icon">
                <Image src={energy} alt="Save Energy" fluid />
            </span>
            <p>Save Energy</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Energy", type: 'Total' } })}>
                        <b>{themeWiseCount.energySavedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Energy", type: 'Completed' } })}>
                        <b>{themeWiseCount.energyCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Energy", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.energyOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Energy", type: 'Initiated' } })}>
                        <b>{themeWiseCount.energyInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D3F9D8' }}>
            <span className="theme-icon">
                <Image src={water} alt="Save Water" fluid />
            </span>
            <p>Save Water</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Water", type: 'Total' } })}>
                        <b>{themeWiseCount.waterSavedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Water", type: 'Completed' } })}>
                        <b>{themeWiseCount.waterCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Water", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.waterOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Save Water", type: 'Initiated' } })}>
                        <b>{themeWiseCount.waterInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FFE6E6' }}>
            <span className="theme-icon">
                <Image src={plastic} alt="Say No to Single Use Plastic" fluid />
            </span>
            <p>Say No to Single Use Plastic</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Say No to Single Use Plastic", type: 'Total' } })}>
                        <b>{themeWiseCount.plasticReducedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Say No to Single Use Plastic", type: 'Completed' } })}>
                        <b>{themeWiseCount.plasticCompletedCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Say No to Single Use Plastic", type: 'Ongoing' } })}>
                        <b>{themeWiseCount.plasticOngoingCount || 0}</b>
                    </td>
                    <td onClick={() => navigate('/admin/view-state', { state: { state:'Uttar Pradesh' , themeLabel: "Say No to Single Use Plastic", type: 'Initiated' } })}>
                        <b>{themeWiseCount.plasticInitiatedCount || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

        </ul>
    </div>
</Container>




                <div className="schlDashbrdRgt">
                    <div className="superFullDashboardDiv mt-1">
                        <div className="row">
                            <div className="col-5 col-xs-12 mapindiadiv">
                                <div className="btmTableDivIn">
                                    <div className="tableTopDiv">
                                        <h4 className="bold-text">Number of Events (District wise:  { filterData?.state || ""})</h4>
                                        <div className="Download">
                                            <FaDownload size={20} color="black" onClick={() => Helper.exportTableToCSV('ECO Club District Wise.csv', 'District', districtWiseData)} />
                                        </div>
                                        <div className="table-responsive">
                                            <table rules="all" className="table">
                                                <thead className="text-primary">
                                                    <tr className="tblHdngOne">
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                        <th colSpan={filterData.implemnt_mode ? 1 : 2}>Mode of Implementation </th>
                                                    </tr>
                                                    <tr>
                                                        <th>Districts</th>
                                                        <th>Total</th>
                                                        <th>Completed</th>
                                                        {filterData.implemnt_mode === "Digital" && (
                                                            <th>Digital</th>
                                                        )}
                                                        {filterData.implemnt_mode === "Physical" && (
                                                            <th>Physical</th>
                                                        )}
                                                        {!filterData.implemnt_mode && (
                                                            <>
                                                                <th>Digital</th>
                                                                <th>Physical</th>
                                                            </>
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {districtWiseData && Object.entries(districtWiseData).map(([district, counts]) => (
                                                        <tr key={district}>
                                                            <td onClick={() => handleClickFilter(district)}><Link>{district}</Link></td>
                                                            <td onClick={() => counts.totalCount !== 0 ? handleClickFilter(district) : ""}><Link>{counts.totalCount || 0}</Link></td>
                                                            <td onClick={() => counts.totalCount !== 0 ? handleClickFilter(district) : ""}><Link>{counts.totalCount || 0}</Link></td>
                                                            {filterData.implemnt_mode === "Digital" && (
                                                                <td onClick={() => counts.digitalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Digital' }) : ""}><Link>{counts.digitalCount || 0}</Link></td>
                                                            )}
                                                            {filterData.implemnt_mode === "Physical" && (
                                                                <td onClick={() => counts.physicalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Physical' }) : ""}><Link>{counts.physicalCount || 0}</Link></td>
                                                            )}
                                                            {!filterData.implemnt_mode && (
                                                                <>
                                                                    <td onClick={() => counts.digitalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Digital' }) : ""}><Link>{counts.digitalCount || 0}</Link></td>
                                                                    <td onClick={() => counts.physicalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Physical' }) : ""}><Link>{counts.physicalCount || 0}</Link></td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-7 col-xs-12 fullBoxData">
                                <Row>
                                    <h4 className="mb-2 bold-text">Total Impact  (Theme wise)</h4>
                                    <Col lg="4" md="6" sm="6" className="boxOne _2">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <MdOutlineEnergySavingsLeaf />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Energy Saved (Total Energy Saved Conserved Watts)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    767
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    <Col lg="4" md="6" sm="6" className="boxOne _3">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaHandHoldingWater />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Water Saved (Water Saved Conserved Ltrs)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    209
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    <Col lg="4" md="6" sm="6" className="boxOne _4">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <TbVaccineBottleOff />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">amount of single use plastic collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    278
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _5">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <IoFastFood />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Sustainable Food Systems Adopted (Total no. of points earned)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    160
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _6">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaBox />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">No. of compost pits established</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    1
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _7">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <IoMan />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">LiFEStyles Adopted (Total no of points earned)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    230
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _8">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaBoxesPacking />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">amount of E-Waste collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    580
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    
                                </Row>
                            </div>
                            <Col sm={12} md={6} lg={6} className="mt-3">
                                        <Card className="card-chart">
                                            <CardHeader>
                                                <Row>
                                                    <Col md="12">
                                                        <div className="d-flex justify-content-center w-100 mt-2" >
                                                            <div className="d-flex justify-content-start mr-5" style={{ marginRight: '15px' }}>
                                                                <Form.Check name="status" value="1" style={{ marginRight: '5px' }} onClick={() => setChartStatus(1)} type="radio" defaultChecked ></Form.Check>
                                                                <Form.Label className="ml-2">Quarter Wise</Form.Label>
                                                            </div>
                                                            <div className="d-flex justify-content-start mr-5" style={{ marginRight: '15px' }}>
                                                                <Form.Check name="status" value="2" style={{ marginRight: '5px' }} onClick={() => setChartStatus(2)} type="radio" ></Form.Check>
                                                                <Form.Label className="ml-2">Month Wise</Form.Label>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardHeader>
                                            <CardBody>
                                                {chartStatus === 1 ? <ApexChartQuarterWise dynamicData={quarterWiseData} />
                                                    : <ApexChartMonthWise dynamicData={monthWiseData} />}
                                            </CardBody>
                                        </Card>
                                    </Col>

                                    <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="card p-4">
                                <h5 className="bold-text">Counts of Events (Age wise)</h5>
                                <CircleChart2 />
                            </div>
                        </Col>
                        </div>
                    </div>
                </div>
                <div className="mt-2 mb-4 mapindiadiv mt-4">
                    <h4 style={{ fontWeight: 'bold', color: '#000000', fontSize: '24px' }}>
                        Visual Representation
                    </h4>
                </div>

                <Container fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="card p-4">
                                <h5 className="bold-text">Counts of Events (Theme wise)</h5>
                                <LineCharts />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="card p-4 barCharts">
                                <BarCharts />
                            </div>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6} >
                            <div className="card p-4">
                                <ApexChartHeatmap />
                            </div>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6} >
                            <div className="card p-4">
                                <ApexChartHeatmap2 />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section >
        </>
    );
}

export default LevelTwoDashboard;
